import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { initialUiState, type ModalPayload } from '@/types/UiState';

export const uiSlice = createSlice({
  name: 'ui',
  initialState: initialUiState,
  reducers: {
    // ---------------- existing reducers ----------------
    openModal: (state, action: PayloadAction<ModalPayload>) => {
      state.modal = action.payload.modal;
      state.modalProps = action.payload.modalProps;
    },
    closeModal: (state) => {
      state.modal = null;
      state.modalProps = undefined;
    },
    setShowLoader: (state) => {
      state.loaderCount += 1;
    },
    setHideLoader: (state) => {
      state.loaderCount = Math.max(0, state.loaderCount - 1);
    },
    setErrorMessage: (state, action: PayloadAction<string | null>) => {
      state.errorMessage = action.payload;
    },

    // ---------------- polling modal reducers ----------------
    setPollingSuccess: (
      state,
      action: PayloadAction<{ title: string; message: string; resourceUrl?: string | null }>
    ) => {
      state.pollingModal = {
        type: 'success',
        title: action.payload.title,
        message: action.payload.message,
        resourceUrl: action.payload.resourceUrl ?? null,
        details: null,
      };
    },

    setPollingError: (
      state,
      action: PayloadAction<{ title: string; message: string; details?: Record<string, unknown> | null }>
    ) => {
      state.pollingModal = {
        type: 'error',
        title: action.payload.title,
        message: action.payload.message,
        resourceUrl: null,
        details: action.payload.details ?? null,
      };
    },

    clearPollingModal: (state) => {
      state.pollingModal = { type: null };
    },
  },
});

export const {
  openModal,
  closeModal,
  setShowLoader,
  setHideLoader,
  setErrorMessage,
  setPollingSuccess,
  setPollingError,
  clearPollingModal,
} = uiSlice.actions;

export default uiSlice.reducer;
